import React from 'react'

import { Button, Dialog, DialogBody, DialogFooter, DialogHeader, Paragraph, useDialogState } from '../components'

interface HelpDialogProps {
  hasNewQuoteMenu: boolean
}

export function HelpDialog(props: HelpDialogProps) {
  const dialog = useDialogState()

  return (
    <>
      <button
        className="btn right"
        style={props.hasNewQuoteMenu ? {} : { marginRight: 0 }}
        onClick={() => {
          dialog.show()
          window.gtag?.('event', 'help', { event_category: 'ideas' })
        }}
      >
        How it works
      </button>
      <Dialog state={dialog} data-testid="charts-help-modal" aria-label="How it works">
        <DialogHeader onCloseClick={() => dialog.hide()}>Help</DialogHeader>
        <DialogBody className="w-145 space-y-4">
          <Paragraph>Drag the chart to the right to see historical data.</Paragraph>
          <Paragraph>
            Choose a tool from the panel on the left. Click on a chart to start drawing. Move your mouse and click again
            to add more points to a shape.
          </Paragraph>
          <Paragraph>Double-click on a drawing to edit its color.</Paragraph>
          <Paragraph>Right-click on a drawing to move it between layers or delete it.</Paragraph>
        </DialogBody>
        <DialogFooter>
          <Button onClick={() => dialog.hide()} data-testid="charts-help-modal-cancel">
            Close
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  )
}
